{
  "app": {
    "name": "Holistic Flow"
  },
  "home": {
    "hero": {
      "title": "Pilates that changes more than your body",
      "subtitle": "Discover classical Pilates guided by an experienced instructor. Live classes and an on-demand library are waiting for you every day.",
      "imageAlt": "Pilates",
      "ctaPrimary": "Start now",
      "ctaSecondary": "Go to the workouts"
    },
    "about": {
      "tagline": "Story",
      "title": "Passion and experience",
      "description": "Since 2020 I have been teaching online, building a community of people who believe in the power of classical Pilates. Every lesson combines precision, calm and a smile.",
      "features": [
        "Over six years of experience in classical Pilates",
        "A regular group of happy online participants",
        "Numerous certificates and specialist training courses"
      ],
      "imageAlt": "Pilates instructor",
      "cta": "About me"
    },
    "pillars": {
      "tagline": "Pillars",
      "title": "Three ways to transform your body",
      "description": "Every part of the Holistic Flow platform is designed with your practice in mind. Whether you prefer to work at your own pace or look for the energy of a live class, we have something for you.",
      "items": [
        {
          "title": "On-demand library",
          "description": "Access hundreds of lessons whenever you need them."
        },
        {
          "title": "Live classes",
          "description": "Connect with the instructor and other participants in real time."
        },
        {
          "title": "Holistic approach",
          "description": "Pilates that supports both body and mind."
        }
      ],
      "cta": "Explore"
    },
    "benefits": {
      "tagline": "Results",
      "title": "What regular practice gives you",
      "description": "Pilates is more than exercise. It is a path to feeling better, to a stronger body and a calmer mind. Every lesson brings you closer to the version of yourself you want to be.",
      "imageAlt": "Pilates benefits",
      "cta": "Start"
    },
    "pricing": {
      "tagline": "Packages",
      "title": "Pricing",
      "description": "Choose the plan that fits your lifestyle.",
      "validity": "{days} days",
      "cta": "Start"
    },
    "testimonials": {
      "title": "What participants say",
      "items": [
        {
          "quote": "Agata's courses changed the way I relate to my body. Every lesson is full of precision and care.",
          "author": "Maria K.",
          "role": "Participant"
        },
        {
          "quote": "I never thought Pilates could be so transformative. I recommend it to every woman!",
          "author": "Anna S.",
          "role": "Participant"
        },
        {
          "quote": "A wonderful instructor whose passion you can feel. Classes are adapted to every level.",
          "author": "Katarzyna M.",
          "role": "Participant"
        }
      ]
    },
    "faq": {
      "title": "Frequently asked questions",
      "items": [
        {
          "question": "Can I start Pilates if I have never done it before?",
          "answer": "Of course! My courses are adapted to every level, from beginner to advanced. Everyone works at their own level."
        },
        {
          "question": "What is the difference between live and on-demand classes?",
          "answer": "Live classes offer direct interaction with me and other participants in real time. On-demand gives you flexibility - you can practise at any time."
        },
        {
          "question": "Can I cancel my subscription at any time?",
          "answer": "Yes, you can cancel at any time with no commitment. I want you to feel comfortable with our platform."
        },
        {
          "question": "What if I have health problems or an injury?",
          "answer": "I can support you with exercise modifications. Contact me directly to discuss your needs."
        }
      ]
    },
    "cta": {
      "title": "Ready to transform?",
      "subtitle": "Join hundreds of participants who have already changed their lives through Pilates.",
      "button": "Start today"
    }
  },
  "video": {
    "loading": "Loading lessons...",
    "errorLoading": "Unable to load lessons. Please try again.",
    "retry": "Retry",
    "empty": "No lessons available yet.",
    "duration": "{minutes} min",
    "category": {
      "pre-pilates": "Pre-Pilates",
      "abs": "Abs",
      "glutes": "Glutes",
      "ball": "Ball",
      "order": "Order",
      "youtube": "YouTube"
    },
    "equipment": {
      "mat": "Mat",
      "ball": "Ball",
      "weights": "Weights",
      "ring": "Ring",
      "stick": "Stick",
      "roller": "Roller",
      "reformer": "Reformer"
    },
    "difficultyLabel": "Difficulty",
    "difficultyValue": "Level {level} of {max}",
    "thumbnailAlt": "Thumbnail for {title}",
    "page": {
      "hero": {
        "title": "Workout library",
        "subtitle": "Recorded classical Pilates lessons, available 24/7. Practise wherever and whenever you want with Holistic Flow.",
        "ctaPrimary": "Get access",
        "ctaSecondary": "Browse lessons"
      },
      "benefits": {
        "tagline": "Benefits",
        "title": "Practise on your own terms",
        "description": "Lessons available any time of day or night. Your schedule, your practice, your pace.",
        "items": [
          {
            "title": "Lessons for every level",
            "description": "From your very first steps to advanced sequences, you will find exactly what you need."
          },
          {
            "title": "Progress without rushing",
            "description": "Move forward at your own pace, with no pressure and no comparison to others."
          },
          {
            "title": "Professional guidance",
            "description": "Every lesson is led by an experienced classical Pilates teacher."
          }
        ]
      },
      "listTitle": "Available lessons"
    },
    "detail": {
      "breadcrumb": "On-demand library",
      "notFound": "Lesson not found.",
      "backToList": "Back to the library",
      "equipmentTitle": "Equipment required",
      "equipmentEmpty": "This lesson needs no equipment.",
      "descriptionEmpty": "A description of this lesson is coming soon.",
      "ctaPrimary": "Start the lesson",
      "ctaSecondary": "Buy access",
      "accordionDetailsTitle": "Lesson details",
      "accordionDetailsContent": "The lesson covers a warm-up, a main part focused on the key elements of Pilates, and a cool-down. Every movement is explained step by step to keep it safe and effective.",
      "testimonialsTitle": "What participants say",
      "testimonials": [
        {
          "quote": "This lesson changed my life! I feel stronger and much more flexible.",
          "author": "Anna K.",
          "role": "Participant"
        },
        {
          "quote": "The instructor is amazing. Every movement is explained precisely.",
          "author": "Maria S.",
          "role": "Participant"
        },
        {
          "quote": "I recommend it to all my friends. This lesson is worth trying!",
          "author": "Katarzyna M.",
          "role": "Participant"
        }
      ],
      "ctaTitle": "Ready for a change?",
      "ctaSubtitle": "Join hundreds of participants who are already practising this lesson.",
      "ctaButton": "Sign in or buy access",
      "play": "Play the lesson",
      "playbackError": "Could not start the video. Please try again."
    }
  },
  "classes": {
    "loading": "Loading classes...",
    "errorLoading": "Unable to load classes. Please try again.",
    "retry": "Retry",
    "empty": "No upcoming classes.",
    "newClass": "New class",
    "edit": "Edit",
    "cancel": "Cancel class",
    "confirmCancel": "Cancel this class? This cannot be undone.",
    "forceDelete": "Delete permanently",
    "confirmForceDelete": "Permanently delete this class? It will be removed from the database and cannot be recovered.",
    "saveError": "Could not save the class. Please try again.",
    "cancelError": "Could not cancel the class. Please try again.",
    "forceDeleteError": "Could not delete the class. Please try again.",
    "status": {
      "scheduled": "Scheduled",
      "cancelled": "Cancelled"
    },
    "enrolled": "{enrolled} / {capacity}",
    "form": {
      "createTitle": "New class",
      "editTitle": "Edit class",
      "title": "Title",
      "instructor": "Instructor",
      "scheduledAt": "Date & time",
      "duration": "Duration (minutes)",
      "capacity": "Capacity",
      "description": "Description",
      "save": "Save",
      "saving": "Saving...",
      "close": "Close"
    },
    "page": {
      "hero": {
        "title": "Live classes",
        "subtitle": "Practise Pilates online, live with an experienced instructor. Find out more about our classes and book your spot today.",
        "ctaPrimary": "Join",
        "ctaSecondary": "Schedule"
      },
      "steps": [
        {
          "number": "01",
          "title": "Choose a class",
          "description": "Browse the schedule and find the one that suits you"
        },
        {
          "number": "02",
          "title": "Book your spot",
          "description": "Pick your date and reserve a place in the group"
        },
        {
          "number": "03",
          "title": "Join the session",
          "description": "Log in at the scheduled time and practise online"
        }
      ],
      "scheduleTitle": "Class schedule"
    },
    "duration": "{minutes} min"
  },
  "about": {
    "hero": {
      "tagline": "Your teacher",
      "name": "Agata Wójcik",
      "bio": "I have been teaching classical Pilates since 2020, completing advanced training covering mat work, apparatus, movement anatomy, spinal conditions, pelvic floor muscles and Pilates for pregnant women. My practice reaches participants all over the world.",
      "imageAlt": "Agata Wójcik — classical Pilates instructor",
      "ctaPrimary": "Book now",
      "ctaSecondary": "Explore"
    },
    "stats": {
      "tagline": "Numbers",
      "title": "Years of practice... and this is only the beginning",
      "description": "Since 2020 I have been teaching classes that changed many people's lives. The numbers below reflect how many — but here quality always plays first violin.",
      "cta": "Join",
      "items": [
        {
          "number": "6",
          "label": "Years of experience"
        },
        {
          "number": "1000+",
          "label": "Online classes taught"
        },
        {
          "number": "18",
          "label": "Recorded workouts"
        }
      ]
    },
    "values": {
      "tagline": "Values",
      "title": "What drives me",
      "description": "I believe in the power of calm and consistency. I teach Pilates, but above all I teach listening to yourself.",
      "items": [
        {
          "title": "Calm",
          "subtitle": "The foundation",
          "description": "Every lesson is a space free of hurry. Here time flows differently."
        },
        {
          "title": "Trust",
          "subtitle": "Built slowly",
          "description": "I work with you, not for you. Your body knows what it needs. I only listen."
        },
        {
          "title": "Professionalism",
          "subtitle": "No compromises",
          "description": "I have been refining my practice since 2020. Every lesson is the result of years of experience and study."
        },
        {
          "title": "Consistency",
          "subtitle": "Change takes time",
          "description": "Pilates is not a sprint. It is a marathon in which every step matters and counts."
        },
        {
          "title": "Individuality",
          "subtitle": "Your own path",
          "description": "There are no standard bodies and no standard needs. I adapt every exercise to you."
        },
        {
          "title": "Authenticity",
          "subtitle": "No mask",
          "description": "I teach what I practise every day. My words carry weight because I live by them."
        },
        {
          "title": "Continuous growth",
          "subtitle": "I never stop",
          "description": "Pilates is a complete system of exercise. I never stop studying it, so I can pass it on to you as well as I possibly can."
        },
        {
          "title": "Community",
          "subtitle": "Stronger together",
          "description": "Even though classes may be online, the energy is real. We are part of something bigger."
        }
      ]
    },
    "explore": {
      "title": "See what I have prepared for you",
      "cards": {
        "classes": {
          "title": "Classes",
          "description": "Browse upcoming classes and reserve your spot."
        },
        "passes": {
          "title": "Passes",
          "description": "Your entries for classes — single class or monthly."
        },
        "bookings": {
          "title": "Bookings",
          "description": "See and manage your upcoming reservations."
        },
        "videos": {
          "title": "Recorded Pilates workouts",
          "description": "Practise classical Pilates with me anytime — no booking required."
        }
      }
    }
  },
  "notFound": {
    "title": "Page Not Found",
    "description": "The page you're looking for doesn't exist or has been moved.",
    "returnHome": "Return Home"
  },
  "player": {
    "loading": "Loading video...",
    "error": "Unable to load video",
    "errorHint": "The video may have expired. Click below to reload.",
    "reload": "Reload Video",
    "unsupported": "Your browser does not support the video tag."
  },
  "nav": {
    "home": "Home",
    "video": "Video",
    "classes": "Classes",
    "passes": "Passes",
    "bookings": "Bookings",
    "profile": "Profile",
    "about": "About",
    "admin": "Admin",
    "menu": "Open navigation",
    "close": "Close navigation"
  },
  "profile": {
    "title": "My Profile",
    "loading": "Loading profile...",
    "errorLoading": "Unable to load profile. Please try again.",
    "retry": "Retry",
    "email": "Email",
    "name": "Full name",
    "phone": "Phone",
    "dateOfBirth": "Date of birth",
    "notes": "Health notes / preferences",
    "save": "Save",
    "saving": "Saving...",
    "saved": "Profile saved.",
    "saveError": "Could not save profile. Please try again."
  },
  "passes": {
    "myPass": "My pass",
    "passTypes": "Pass types",
    "loading": "Loading passes...",
    "errorLoading": "Unable to load passes. Please try again.",
    "retry": "Retry",
    "emptyTypes": "No pass types available.",
    "noActivePass": "You don't have an active pass.",
    "newPassType": "New Pass Type",
    "edit": "Edit",
    "saveError": "Could not save the pass type. Please try again.",
    "grantSuccess": "Pass granted, valid until {date}.",
    "grantError": "Could not grant pass. Please try again.",
    "entriesRemaining": "{entries} entries remaining",
    "unlimited": "Unlimited",
    "validUntil": "Valid until {date}",
    "status": {
      "active": "Active",
      "expired": "Expired",
      "exhausted": "Exhausted",
      "cancelled": "Cancelled"
    },
    "form": {
      "createTitle": "New Pass Type",
      "editTitle": "Edit Pass Type",
      "name": "Name",
      "entries": "Entries",
      "unlimitedLabel": "Unlimited",
      "price": "Price (PLN)",
      "currency": "Currency",
      "validityDays": "Validity (days)",
      "paymentUrl": "Payment URL",
      "save": "Save",
      "saving": "Saving...",
      "close": "Close"
    },
    "grantForm": {
      "title": "Grant Pass",
      "user": "User",
      "selectUser": "Select user",
      "loadingUsers": "Loading users...",
      "me": "me",
      "passType": "Pass Type",
      "selectPassType": "Select pass type",
      "submit": "Grant",
      "submitting": "Granting..."
    },
    "page": {
      "subtitle": "Choose the plan that suits you",
      "myPass": {
        "text": "Go to your profile to see your active pass and how many entries are left."
      },
      "buy": {
        "title": "Buy a pass",
        "text": "Available packages and pricing are on the home page, in the “Packages” section."
      },
      "manage": {
        "title": "Manage passes",
        "text": "Go to the admin panel to manage pass types and grant them to users.",
        "cta": "Admin panel"
      }
    },
    "deleteConfirm": "Permanently delete this pass type? This cannot be undone.",
    "deleteError": "Could not delete the pass type",
    "entriesCount": "{entries} entries",
    "validityShort": "{days}d"
  },
  "bookings": {
    "loading": "Loading bookings...",
    "errorLoading": "Unable to load bookings. Please try again.",
    "retry": "Retry",
    "empty": "No bookings yet.",
    "emptyCancelled": "No cancelled bookings.",
    "showCancelled": "Show cancelled",
    "hideCancelled": "Hide cancelled",
    "forceDelete": "Delete permanently",
    "confirmForceDelete": "Permanently delete this booking record?",
    "forceDeleteError": "Could not delete the booking. Please try again.",
    "bookClass": "Book",
    "alreadyBooked": "Already booked",
    "classFull": "Class is full",
    "classCancelled": "This class has been cancelled.",
    "classAlreadyStarted": "This class has already started.",
    "noActivePass": "You need an active pass to book classes.",
    "noPassEntries": "Your pass has no remaining entries.",
    "bookError": "Could not book the class. Please try again.",
    "cancel": "Cancel booking",
    "cancelConfirm": "Cancel this booking?",
    "cancelError": "Could not cancel the booking. Please try again.",
    "entryReturned": "Entry returned to your pass.",
    "entryNotReturned": "Booking cancelled. No entry was returned.",
    "roster": "Roster",
    "rosterLoading": "Loading roster...",
    "rosterEmpty": "No bookings for this class.",
    "status": {
      "confirmed": "Confirmed",
      "cancelled": "Cancelled"
    },
    "sourceAuto": "auto"
  },
  "auth": {
    "login": "Log in",
    "logout": "Log out",
    "loading": "Authenticating...",
    "callback": {
      "processing": "Signing you in...",
      "error": "Authentication failed. Please try again.",
      "retry": "Try again"
    },
    "error": {
      "config": "Authentication service unavailable"
    },
    "user": {
      "menu": "User menu",
      "role": {
        "admin": "Admin",
        "instructor": "Instructor",
        "user": "User"
      }
    }
  },
  "admin": {
    "subtitle": "Manage the platform"
  }
}
